/* core libraray */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "src/components/loader";
import { Button } from "@mui/material";
import _ from "lodash";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

/* custom component */
import {
  getAllGoodsInData1,
  getAllGoodsInDataLoading,
} from "src/thunks/goodsin";
import {
  getAllDispatchOrderData,
  getAllDispatchOrderDataLoading,
} from "src/thunks/dispatchOrder";
import { GetError, convertIsoToLocalDateTime } from "src/constant";

export const Dashboard = () => {
  /*  hooks veriable */
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /* getting value from redux storage using useSelector */
  const { filterAllData } = useSelector((state) => state.goodsin);
  const { isDropdownOpenFlagValue } = useSelector((state) => state.dashboard);
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const { allGoodInData, goodsinLoadingState, rightSideBarOpenCloseValue } =
    useSelector((state) => state.goodsin);
  const { allDispatchOrderData, dispatchOrderLoadingState } = useSelector(
    (state) => state.dispatch
  );

  /* component States */
  const [currentPageGoodsIn, setCurrentPageGoodsIn] = useState(1);
  const [totalGoodsPage, setTotalGoodsPage] = useState(0);

  const [currentPageDispatchOrder, setCurrentPageDispatchOrder] = useState(1);
  const [totalDispatchOrder, setTotalDispatchOrder] = useState(0);

  const [goodsInShowDData, setGoodsInShowDData] = useState([]);
  const [dispatchOrderShowDData, setDispatchOrderShowDData] = useState([]);

  /* veriable handle increase width sidebar open and closing */
  const newClass = rightSideBarOpenCloseValue
    ? ""
    : "increase-width-in-dashboard";

  /* getting userdata values from localstorage */
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  /* filtering GoodsIn and Dispatch Data */
  const filterGoodsInAndDispatchDataHandler = (data, status) => {
    return _.filter(data || [], (d) => d?.statusValue === status);
  };

  /* filtering GoodsIn Data */
  const completeStatus = filterGoodsInAndDispatchDataHandler(goodsInShowDData, "Approved")?.length || 0;
  const newStatus = _.filter(goodsInShowDData || [], (d) => d?.typeValue === "New")?.length || 0;

  /* filtering Dispatch Data */
  const reviewCount = filterGoodsInAndDispatchDataHandler(dispatchOrderShowDData, "Review")?.length || 0;
  const pendingCount = filterGoodsInAndDispatchDataHandler(dispatchOrderShowDData, "Pending")?.length || 0;
  const loadingCount = filterGoodsInAndDispatchDataHandler(dispatchOrderShowDData, "Loading")?.length || 0;
  const intransitCount = filterGoodsInAndDispatchDataHandler(dispatchOrderShowDData, "InTransit")?.length || 0;
  const deliveryCount = _.filter(dispatchOrderShowDData, (d) => d.typeId == 19)?.length || 0;
  const collectionCount = _.filter(dispatchOrderShowDData, (d) => d.typeId == 20)?.length || 0;

  /* 60 days date cacluation */
  const currentDate = new Date();
  const last60Days = new Date(currentDate);
  last60Days.setDate(currentDate.getDate() - 60);



  /* calling getDispatchAndGoodsApi funcction for getting goodsin and dispatch data and also remove data after component unmount */
  useEffect(() => {
    getDispatchAndGoodsApi();
    return () => {
      setGoodsInShowDData([]);
    };
  }, []);

  /* The useEffect hook is called when there is a change in the dependencies specified in its dependency allGoodInData array */
  useEffect(() => {
    let result = allGoodInData || [];
    if (result.length > 0) {
      setTotalGoodsPage(result[0]?.totalPages || 0)
    }
    setGoodsInShowDData([...result]);
  }, [allGoodInData]);

  /* The useEffect hook is called when there is a change in the dependencies specified in its dependency allDispatchOrderData array */
  useEffect(() => {
    let result = allDispatchOrderData || [];
    if (result.length > 0) {
      setTotalDispatchOrder(result[0]?.totalPages || 0)
    }
    setDispatchOrderShowDData([...result]);
  }, [allDispatchOrderData]);


  /* handler functions--------------------------------------------------- */
  const getDispatchAndGoodsApi = async () => {
    try {
      let newData = filterAllData["dashboard"];
      let data = {
        isDateRange: true,
        from: newData?.from || moment(last60Days).format("YYYY-MM-DD"),
        to: newData?.to || moment(currentDate).format("YYYY-MM-DD"),
        DepotIds: newData?.DepotIds || [
          userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin"
            ? 0
            : userDetails?.depots[0]?.id,
        ],
        ClientIds: [0],
        ProjectIds: [0],
        currentPage: currentPageGoodsIn,
      };
      await dispatch(getAllGoodsInData1({ ...data })).unwrap();
      await dispatch(getAllDispatchOrderData({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  /* function handle get dispatch data */
  const getDispatchOrderData = async (page) => {
    try {
      let newData = filterAllData['dashboard']
      let data = {
        isDateRange: true,
        from: newData?.from || moment(last60Days).format("YYYY-MM-DD"),
        to: newData?.to || moment(currentDate).format("YYYY-MM-DD"),
        DepotIds: newData?.DepotIds || [
          userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin"
            ? 0
            : userDetails?.depots[0]?.id,
        ],
        ClientIds: [0],
        ProjectIds: [0],
        currentPage: page,
      };
      let res = await dispatch(
        getAllDispatchOrderDataLoading({ ...data })
      ).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  /* function handle get goodsIn data */
  const getGoodsInData = async (page) => {
    try {
      let newData = filterAllData['dashboard']
      let data = {
        isDateRange: true,
        from: newData?.from || moment(last60Days).format("YYYY-MM-DD"),
        to: newData?.to || moment(currentDate).format("YYYY-MM-DD"),
        DepotIds: newData?.DepotIds || [
          userDetails?.roles == "SuperAdmin" || userDetails?.roles == "Admin"
            ? 0
            : userDetails?.depots[0]?.id,
        ],
        ClientIds: [0],
        ProjectIds: [0],
        currentPage: page,
      };
      await dispatch(getAllGoodsInDataLoading({ ...data })).unwrap();
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  /* functon handle load more GoodIn button action */
  const handleLoadMoreGoodsIn = () => {
    setCurrentPageGoodsIn(currentPageGoodsIn + 1);
    getGoodsInData(currentPageGoodsIn + 1);
  };

  /* functon handle load more dispatch button action */
  const handleLoadMoreDispatchOrder = () => {
    setCurrentPageDispatchOrder(currentPageDispatchOrder + 1);
    getDispatchOrderData(currentPageDispatchOrder + 1);
  };
  let TotalDispatch = dispatchOrderShowDData?.length > 0 ? dispatchOrderShowDData[0] : {}
  let GoodsInFirstRow = allGoodInData?.length > 0 ? allGoodInData[0] : {}
  if (goodsinLoadingState || dispatchOrderLoadingState) {
    return <Loader />;
  }
  return (
    <>
      <div
        className={`${isDropdownOpenFlagValue == true || signoutModelOpenFlag == true
          ? "add-overlay-for-depot-dropdown"
          : ""
          } main-dashboard-div d-flex ms-3 me-3`}
      >
        <div className="dashboard-goodsin-part-main-div">
          <div
            className={` ${newClass} d-flex justify-content-between dashboard-goodsin-header-div d-flex align-items-center`}
          >
            <div className="goods-in-header">GOODS IN</div>
            {userDetails?.roles == "DepotManager" ? (
              <>
                <div className="d-flex justify-content-end goods-in-header-subdiv pe-3 ">
                  <div>
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {newStatus}
                    </span>
                    <span className="goodsin-label-shown-for-dm ms-1">
                      {" "}
                      NEW
                    </span>
                  </div>
                  <div className="ms-2">
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {goodsInShowDData?.length - newStatus}
                    </span>
                    <span className="goodsin-label-shown-for-dm ms-1">
                      {" "}
                      RETURNS
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* --------------TOTALSHIPMENTS----------- */}
                <div>
                  <div>
                    <span className="goodsin-count-shown goodsin-approved-count-shown">
                      {GoodsInFirstRow?.totalShipments || 0}
                    </span>
                    <span className="goodsin-label-shown ms-1 m-1">
                      TOTAL SHIPMENTS
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-end goods-in-header-subdiv pe-3 ">
                  <div>
                    <span className="goodsin-count-shown goodsin-approved-count-shown">
                      {GoodsInFirstRow?.totalApproved || 0}
                    </span>
                    <span className="goodsin-label-shown ms-1"> APPROVED</span>
                  </div>
                  <div className="ms-2">
                    <span className="goodsin-count-shown goodsin-review-count-shown">
                      {GoodsInFirstRow?.totalReview || 0}
                    </span>
                    <span className="goodsin-label-shown ms-1"> REVIEW</span>
                  </div>
                </div>
              </>
            )}
          </div>
          {userDetails?.roles == "DepotManager" ? (
            <div className={`${newClass} rightsidebar-nofn`}>
              {goodsInShowDData &&
                goodsInShowDData[0] &&
                goodsInShowDData.map((item, index) => {
                  return (
                    <div
                      key={`goodsDM${index}`}
                      className="dashboard-each-item p-2 mt-3"
                      onClick={
                        () => navigate(`/app/goodsin/detail/${item?.id}`)
                        // --------------------
                      }
                    >
                      <div style={{ flex: 6, display: "flex" }}>
                        <div style={{ flex: 2 }}>
                          <p className="each-row-text-style mb-0">
                            {moment(item?.inTime).format("DD-MMM-YYYY,HH:mm")}
                          </p>
                        </div>
                        <div className="d-flex ps-2" style={{ flex: 2 }}>
                          <p className="depotManagername-text-style mb-0">
                            {item?.depotManager || ""}
                          </p>
                        </div>
                        <div style={{ flex: 2, textAlign: "end" }}>
                          <p
                            className={`${item?.statusValue == "Review"
                              ? "review-status-color"
                              : "approved-status-color"
                              } status-text-style text-uppercase mb-0`}
                          >
                            {item?.statusValue}
                          </p>
                        </div>
                      </div>

                      <div style={{ flex: 6, display: "flex" }}>
                        <div style={{ flex: 2 }} className="pe-2">
                          <p className="cmr-text-style dashboarddepotName-value-style mb-0">
                            {item?.referenceNumber || ""}
                          </p>
                          <p className="clientName-text-style mb-0 dashboardclientName-value-style">
                            <b>{item?.clientName || ""}</b>
                          </p>
                          <p className="address-text-style mb-0 dashboardclientName-value-style">
                            {item?.clientAddress || ""}
                          </p>
                        </div>

                        <div style={{ flex: 2 }}>
                          <p className="items-count-style mb-0">
                            {item?.itemCount || 0} Goods
                          </p>
                          <p className="items-count-style mb-0">
                            {item?.damagedCount || 0} Damaged
                          </p>
                        </div>

                        <div style={{ flex: 2, textAlign: "end" }}>
                          <p className="mb-0 cmr-text-style">
                            {" "}
                            {item?.interiorSpace || 0} m2 [Int]
                          </p>
                          <p className="mb-0 cmr-text-style">
                            {item?.exteriorSpace || 0} m2 [Ext]
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {currentPageGoodsIn < totalGoodsPage && (
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={() => handleLoadMoreGoodsIn()}
                    style={{ height: 25, background: "#0045d9" }}
                    variant="contained"
                  >
                    Load More
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div className={`${newClass} rightsidebar-nofn`}>
              {goodsInShowDData &&
                goodsInShowDData[0] &&
                goodsInShowDData.map((item, index) => {
                  return (
                    <div
                      key={`goodsSA${index}`}
                      className="dashboard-each-item p-2 mt-3"
                      onClick={() =>
                        navigate(`/app/goodsin/detail/${item?.id}`)
                      }
                    >
                      <div style={{ flex: 6, display: "flex" }}>
                        <div style={{ flex: 1.2 }}>
                          <p className="each-row-text-style mb-0">
                            {moment(item?.inTime).format("DD-MMM-YYYY,HH:mm")}
                          </p>
                        </div>
                        <div className="d-flex ps-2" style={{ flex: 3.8 }}>
                          <p className="depotname-text-style  mb-0 dashboarddepotName-value-style">
                            {item?.depotName || ""}
                          </p>
                          <p className="depotManagername-text-style mb-0">
                            {item?.depotManager || ""}{" "}
                          </p>
                        </div>
                        <div style={{ flex: 1, textAlign: "end" }}>
                          <p
                            className={`${item?.statusValue == "Review"
                              ? "review-status-color"
                              : "approved-status-color"
                              } status-text-style text-uppercase mb-0`}
                          >
                            {item?.statusValue}
                          </p>
                        </div>
                      </div>
                      <div style={{ flex: 6, display: "flex" }}>
                        <div style={{ flex: 1.2 }} className="pe-2">
                          <p className="cmr-text-style dashboarddepotName-value-style mb-0">
                            {item?.referenceNumber || ""}
                          </p>
                        </div>
                        <div style={{ flex: 1.5, paddingLeft: 14 }}>
                          <p className="clientName-text-style mb-0 dashboardclientName-value-style">
                            <b>{item?.clientName || ""}</b>
                          </p>
                          <p className="address-text-style mb-0 dashboardclientName-value-style">
                            {item?.clientAddress || ""}
                          </p>
                        </div>
                        <div
                          className="d-flex"
                          style={{ flex: 2, justifyContent: "space-between" }}
                        >
                          <p className="items-count-style mb-0">
                            {item?.itemCount || 0} Items
                          </p>
                          <p className="items-count-style mb-0">
                            {item?.damagedCount || 0} Damaged
                          </p>
                        </div>

                        <div style={{ flex: 2, textAlign: "end" }}>
                          <p className="mb-0 cmr-text-style">
                            {" "}
                            {item?.interiorSpace || 0} m2 [Int]
                          </p>
                          <p className="mb-0 cmr-text-style">
                            {item?.exteriorSpace || 0} m2 [Ext]
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {currentPageGoodsIn < totalGoodsPage && (
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={() => handleLoadMoreGoodsIn()}
                    style={{ height: 25, background: "#0045d9" }}
                    variant="contained"
                  >
                    Load More
                  </Button>
                </div>
              )}
            </div>
          )}
        </div>

        <div style={{ width: "50%", overflow: "scroll" }}>
          <div
            className={`${newClass} d-flex justify-content-between dashboard-goodsin-header-div d-flex align-items-center`}
          >
            <div className="ms-3 dispatch-header">DISPATCHES</div>
            {userDetails?.roles == "DepotManager" ? (
              <>
                <div
                  className="d-flex justify-content-end"
                  style={{ flex: 3.5 }}
                >
                  <div className="label-gap-class">
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {intransitCount}
                    </span>
                    <span className="goodsin-label-shown"> IN-TRANSIT</span>
                  </div>
                  <div className="label-gap-class">
                    <span className="goodsin-count-shown deliveries-count-shown ">
                      {loadingCount}
                    </span>
                    <span className="goodsin-label-shown"> LOADING</span>
                  </div>
                  <div style={{ paddingRight: 10 }}>
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {pendingCount}
                    </span>
                    <span className="goodsin-label-shown"> PENDING</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* ------------- TOTAL-ORDERS----------- */}
                <div>
                  <div>
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {TotalDispatch?.totalOrders || 0}
                    </span>
                    <span className="goodsin-label-shown ms-1 m-1">
                      TOTAL ORDERS
                    </span>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-end"
                  style={{ flex: 3.5 }}
                >
                  <div className="label-gap-class">
                    <span className="goodsin-count-shown deliveries-count-shown">
                      {/* {deliveryCount} */}
                      {TotalDispatch?.totalDeliveries}
                    </span>
                    <span className="goodsin-label-shown"> DELIVERIES</span>
                  </div>
                  <div className="label-gap-class">
                    <span className="goodsin-count-shown deliveries-count-shown ">
                      {TotalDispatch?.totalCollections}
                      {/* {collectionCount/} */}
                    </span>
                    <span className="goodsin-label-shown"> COLLECTIONS</span>
                  </div>
                  <div style={{ paddingRight: 10 }}>
                    <span className="goodsin-count-shown goodsin-review-count-shown">
                      {TotalDispatch?.totalReview}
                      {/* {reviewCount} */}
                    </span>
                    <span className="goodsin-label-shown"> REVIEW</span>
                  </div>
                </div>
              </>
            )}
          </div>

          {userDetails?.roles == "DepotManager" ? (
            <div className={`${newClass} rightsidebar-nofn ms-3`}>
              {dispatchOrderShowDData &&
                dispatchOrderShowDData[0] &&
                dispatchOrderShowDData
                  .filter((d) => d?.statusValue !== "Review")
                  .map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        <div
                          className="dashboard-each-item p-2 mt-3"
                          onClick={() =>
                            navigate(`/app/dispatchorders/detail/${item?.id}`)
                          }
                        >
                          <div className="d-flex" style={{ flex: 8 }}>
                            <div className="each-column-in-row-for-goodsin">
                              <p
                                className={`duetime-text-style mb-0   
                               ${item.statusValue == "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "add-dispatch-tbl-black-status-color"
                                  }`}
                              >
                                {convertIsoToLocalDateTime(`${item?.dueDate}.00Z`, "DD-MMM-YYYY , HH:mm")}
                              </p >
                            </div >
                            <div className="each-column-in-row-for-goodsin-little-big">
                              <p
                                className={`depotManagername-text-style dashboardclientName-value-style-dispatch mb-0  
                               ${item.statusValue == "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "add-dispatch-tbl-black-status-color"
                                  }`}
                              >
                                {item?.depotManager || ""}
                              </p>
                            </div>
                            <div className="each-column-in-row-for-goodsin">
                              <p
                                className={`duetime-text-style mb-0 text-uppercase 
                              ${item.statusValue == "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "add-dispatch-tbl-black-status-color"
                                  }`}
                              >
                                {moment(
                                  item?.eventDate || ""
                                ).format("HH:mm")}
                              </p>
                            </div>
                            <div
                              className="each-column-in-row-for-goodsin text-uppercase"
                              style={{ textAlign: "end" }}
                            >
                              <p
                                className={`${["Pending", "Review"].includes(
                                  item?.statusValue
                                )
                                  ? "red-dispatch-status-color"
                                  : item?.statusValue == "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "blue-dispatch-status-color"
                                  } duetime-text-style mb-0`}
                              >
                                {item?.statusValue}
                              </p>
                            </div>
                          </div >
                          <div style={{ flex: 8, display: "flex" }}>
                            <div style={{ flex: 2 }} className="pe-2">
                              <p className={`cmr-text-style dashboarddepotName-value-style mb-0  
                               ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}>
                                {item.orderNo}
                              </p>
                              <p className={`clientName-text-style mb-0 dashboarddepotName-value-style  
                              ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`} style={{ paddingLeft: 12 }}>
                                <b>{item?.clientName}</b>
                              </p>
                              <p className={`address-text-style mb-0 dashboarddepotName-value-style 
                                 ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}>
                                {item?.clientAddress || ""}
                              </p>
                            </div>

                            <div style={{ flex: 2 }}>
                              <p className={`cmr-text-style mb-0  
                              ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}>
                                {item.dispatchItemCount} Goods{" "}
                              </p>
                            </div>

                            <div style={{ flex: 2 }}>
                              <p className={`cmr-text-style mb-0  
                               ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}>
                                {item?.statusValue === "Pending" ||
                                  item?.statusValue === "Review"
                                  ? "--"
                                  : item?.interiorSpace || 0}{" "}
                                m<sup>2</sup> (o)
                              </p>
                              <p className="cmr-text-style mb-0">
                                {" "}
                                <p className={`cmr-text-style mb-0 
                               ${item.statusValue == "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "add-dispatch-tbl-black-status-color"
                                  }`}>
                                  {item?.statusValue === "Pending" ||
                                    item?.statusValue === "Review"
                                    ? "--"
                                    : item?.exteriorSpace || 0}{" "}
                                  m<sup>2</sup> (c)
                                </p>
                              </p>
                            </div>

                            <div
                              className="d-flex justify-content-end"
                              style={{ flex: 2, textAlign: "end" }}
                            >
                              <p className={`cmr-text-style dashboardvehiclecount-value-style-dispatch mb-0 
                              ${item.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}>
                                {item?.vehicle || 0}{" "}
                                Vehicle(s)
                              </p>
                            </div>
                          </div>
                        </div >
                      </React.Fragment >
                    );
                  })}
              {currentPageDispatchOrder < totalDispatchOrder && (
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={() => handleLoadMoreDispatchOrder()}
                    style={{ height: 25, background: "#0045d9" }}
                    variant="contained"
                  >
                    Load More
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div className={`${newClass} rightsidebar-nofn ms-3`}>
              {dispatchOrderShowDData &&
                dispatchOrderShowDData[0] &&
                dispatchOrderShowDData.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div
                        className="dashboard-each-item p-2 mt-3"
                        onClick={() =>
                          navigate(`/app/dispatchorders/detail/${item?.id}`)
                        }
                      >
                        <div className="first-row-in-goodsin d-flex">
                          <div className="each-column-in-row-for-goodsin">
                            <p
                              className={`duetime-text-style mb-0
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {convertIsoToLocalDateTime(`${item?.dueDate}.00Z`, "DD-MMM-YYYY , HH:mm")}
                            </p >
                          </div >
                          <div className="each-column-in-row-for-goodsin-little-big">
                            <p
                              className={`duetime-text-style mb-0 dashboardclientName-value-style
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item?.depotName || ""}
                            </p>
                          </div>
                          <div className="each-column-in-row-for-goodsin-little-big">
                            <p
                              className={`depotManagername-text-style dashboardclientName-value-style-dispatch mb-0  
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item?.depotManager || ""}
                            </p>
                          </div>
                          <div className="each-column-in-row-for-goodsin">
                            <p
                              className={`duetime-text-style mb-0
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {moment(
                                item?.eventDate || ""
                              ).format("HH:mm")}

                            </p>
                          </div>
                          <div
                            className="each-column-in-row-for-goodsin text-uppercase"
                            style={{ textAlign: "end" }}
                          >
                            <p
                              className={`${["Pending", "Review"].includes(
                                item?.statusValue
                              )
                                ? "red-dispatch-status-color"
                                : item?.statusValue == "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "blue-dispatch-status-color"
                                } duetime-text-style mb-0`}
                            >
                              {item?.statusValue}
                            </p>
                          </div>
                        </div >

                        <div style={{ flex: 6, display: "flex" }}>
                          <div style={{ flex: 1.2 }} >
                            <p
                              className={`cmr-text-style dashboarddepotName-value-style mb-0
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item.orderNo}
                            </p>
                          </div>
                          <div style={{ flex: 1.2 }}>
                            <p
                              className={`clientName-text-style mb-0 dashboarddepotName-value-style
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              <b>{item?.clientName}</b>
                            </p>
                            <p
                              className={`address-text-style mb-0 dashboarddepotName-value-style
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item?.clientAddress || ""}
                            </p>
                          </div>

                          <div className="d-flex" style={{ flex: 1.3 }}>
                            <p
                              className={`cmr-text-style mb-0  
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item.dispatchItemCount} of{" "}
                              {item.itemCount} Items
                            </p>
                          </div>

                          <div style={{ flex: 1.3 }}>
                            <p
                              className={`cmr-text-style mb-0
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item?.statusValue === "Pending" ||
                                item?.statusValue === "Review"
                                ? "--"
                                : item?.interiorSpace}{" "}
                              m<sup>2</sup>
                            </p>
                            <p className="cmr-text-style mb-0">
                              {" "}
                              <p
                                className={`cmr-text-style mb-0
                               ${item.statusValue === "Loading"
                                    ? "add-dispatch-tbl-loading-status-color"
                                    : item.statusValue == "Cancelled"
                                      ? "red-clientname-color"
                                      : "add-dispatch-tbl-black-status-color"
                                  }`}
                              >
                                {item?.statusValue === "Pending" ||
                                  item?.statusValue === "Review"
                                  ? "--"
                                  : item?.exteriorSpace || 0}{" "}
                                m<sup>2</sup>
                              </p>
                            </p>
                          </div>
                          <div
                            className="d-flex justify-content-end"
                            style={{ flex: 1, textAlign: "end" }}
                          >
                            <p
                              className={`cmr-text-style dashboardvehiclecount-value-style-dispatch mb-0
                             ${item.statusValue === "Loading"
                                  ? "add-dispatch-tbl-loading-status-color"
                                  : item.statusValue == "Cancelled"
                                    ? "red-clientname-color"
                                    : "add-dispatch-tbl-black-status-color"
                                }`}
                            >
                              {item?.vehicles || 0}{" "}
                              Vehicle(s)
                            </p>
                          </div>
                        </div>
                      </div >
                    </React.Fragment >
                  );
                })}
              {currentPageDispatchOrder < totalDispatchOrder && (
                <div className="d-flex justify-content-center">
                  <Button
                    onClick={() => handleLoadMoreDispatchOrder()}
                    style={{ height: 25, background: "#0045d9" }}
                    variant="contained"
                  >
                    Load More
                  </Button>
                </div>
              )}
            </div>
          )}
        </div >
      </div >
    </>
  );
};
